module.exports = __webpack_public_path__ + "media/images/pathway_illustrations/ASTROPHYSICS-ASTRONOMY-e8a49003b6b61a4f87bb2f1b64eab3f0.png";